'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  box-sizing: border-box;\n  ', '\n'], ['\n  box-sizing: border-box;\n  ', '\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactCreateComponentFromTagProp = require('react-create-component-from-tag-prop');

var _reactCreateComponentFromTagProp2 = _interopRequireDefault(_reactCreateComponentFromTagProp);

var _gridUnit = require('../mixins/gridUnit');

var _gridUnit2 = _interopRequireDefault(_gridUnit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GridUnitComponent = (0, _reactCreateComponentFromTagProp2.default)({
  tag: 'div',
  prop: 'component',
  propsToOmit: ['width', 'visible']
});

var GridUnit = (0, _styledComponents2.default)(GridUnitComponent)(_templateObject, _gridUnit2.default);

GridUnit.propTypes = {
  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object]),
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.object]),
  visible: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.object])
};

exports.default = GridUnit;


//////////////////
// WEBPACK FOOTER
// ./~/styled-components-grid/dist/cjs/components/GridUnit.js
// module id = 705
// module chunks = 168707334958949